;(function (angular, _) {
  'use strict'

  class SubcontractorListToolbarController {
    constructor (
      // Angular
      $rootScope,
      // Libs
      $uibModal
      // Managers
      // Services
      // Const
      // Resolved
    ) {
      this.rootScope = $rootScope
      this.uibModal = $uibModal
    }

    createSubcontractor () {
      return this.uibModal.open({
        size: 'lg',
        controller: 'EditSubcontractorModalController',
        controllerAs: '$ctrl',
        templateUrl: '/app/modules/subcontractor/modals/edit-subcontractor/edit-subcontractor-modal.template.html',
        resolve: {
          subcontractor: ['EntityManager', function (EntityManager) {
            return EntityManager.create({ __t: 'EntitySubcontractor' })
          }]
        }
      }).result.then((entity) => {
        entity.save().then(() => {
          this.rootScope.$broadcast('new-subcontractor')
        })
      })
    }
  }

  SubcontractorListToolbarController.$inject = [
    // Angular
    '$rootScope',
    // Libs
    '$uibModal'
    // Managers
    // Services
    // Const
    // Resolved
  ]

  angular.module('kilo.routes.subcontractor.list')
    .controller('SubcontractorListToolbarController', SubcontractorListToolbarController)
})(window.angular, window._)
